import getRouteAdmin from './routeAdmin.js'
import getRouteMember from './routeMember.js'
import getRouteNotFound from './routeNotFound.js'

const routes = {
  getRouteAdmin,
  getRouteMember,
  getRouteNotFound
}

export default routes
